module.exports = __webpack_public_path__ + "img/youmu konpaku lunar war gardener_sc2.238f5c9b.png";